import bleEventsType from "../../consts/bleEventsType";
import EventEmitter, {IBleEventArgs} from "./EventEmitter";
import log from "../logger/logger";
import { IBleDeviceMessageDataBase, IBleExtensionMessage, IBleExtensionMessageData } from "./Models";

let instance: BleExtensionClient | null = null;

export default class BleExtensionClient {
    constructor() {
        if(instance) return instance;
        instance = this;
        this.#init();
    }

    #lastMessageId = 0;
    #messageEventEmitter = new EventEmitter<IBleExtensionMessage<any>>();

    #init() {
        window.addEventListener("bleExtension-backgroundListener", (event) => {
            const message = (<CustomEvent>event).detail as IBleExtensionMessage<any>;
            log.debug(`bleExtension-backgroundListener data retrieved: ${JSON.stringify(message)}`);
            this.#messageEventEmitter.emit(bleEventsType.onExtensionMessage, {data: message});
        });
    }

    addOnMessageEventListener(handler: (arg0: IBleEventArgs<IBleExtensionMessage<any>>) => void) {
        this.#messageEventEmitter.subscribe(bleEventsType.onExtensionMessage, handler);
    }

    removeOnMessageEventListener(handler: (arg0: IBleEventArgs<IBleExtensionMessage<any>>) => void) {
        this.#messageEventEmitter.unsubscribe(bleEventsType.onExtensionMessage, handler);
    }

    sendMessage(message: IBleDeviceMessageDataBase): number | null {
        try {
            const id = this.#getMessageId();
            log.debug(`Send ble extension message: ${JSON.stringify(message)}`);
            const detail = { data: message, id: id };
            window.dispatchEvent(
                new CustomEvent("bleExtension-sendMessageToBackground", {
                    detail: detail,
                })
            );

            return id;
        } catch (error) {
            log.error(`Error occurred during the sending message to extension: `, error);
            return null;
        }
    }

    #getMessageId() {
        this.#lastMessageId += 1;
        return this.#lastMessageId;
    }
}